// @core/api/endpoints/authn/authorize_device.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AuthorizeDeviceRequest,
  AuthorizeDeviceResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Authorize device (OAuth2 Device Flow)
 * Initiates the OAuth2 Device Authorization flow for input-constrained devices. Returns a device code, user code, and verification URL for the user to complete authorization on another device.
 * @public This endpoint does not require authentication
 */
export async function AuthorizeDevice(
  data: AuthorizeDeviceRequest,
  options?: RequestOptions
): Promise<AuthorizeDeviceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/device/authorize`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<AuthorizeDeviceResponse>(requestPath, data, requestOptions);
}
